import * as React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Dropdown as PrimeDropdown, DropdownProps as PrimeDropdownProps } from 'primereact/dropdown';
import { MultiSelect, MultiSelectProps } from 'primereact/multiselect';
import 'primereact/dropdown/dropdown.min.css';
import cn from 'classnames';

import classes from './dropdown.module.scss';

export type DropdownProps = (PrimeDropdownProps | MultiSelectProps) & {
  isRequired?: boolean;
  labelClassName?: string;
  rootClassName?: string;
  dropdownClassName?: string;
  wrapperDropdownClassName?: string;
  fieldId: string;
  hint?: string;
  label?: string;
  error?: string;
  multi?: boolean;
  name: string;
  control?: Control<any>;
  isLoading?: boolean;
  //filter?:boolean;
  //showSelectAll?:boolean;
  //showClear?:boolean;
};

const SimpleDropdown = ({ fieldId, labelClassName, isRequired, multi, ...props }: DropdownProps) => {
  const dropDownProps = {
    resetFilterOnHide: true,
    inputId: fieldId,
    className:cn(classes.dropdown, props.dropdownClassName, { [classes.dropdownError]: props.error }),
    disabled: props.isLoading,
    ...props
  };

  return (
    <div className={cn(classes.root, props.rootClassName)}>
      <div>
        <label htmlFor={fieldId} className={cn(classes.label, labelClassName)}>
          {props.label}
          {props.label && isRequired ? <span className={classes.asterix}>*</span> : null}
        </label>
      </div>
      <div className={cn(props.isLoading && 'p-input-icon-right', classes.wrapperField, props.wrapperDropdownClassName)}>
        {props.isLoading ? <i className="pi pi-spin pi-spinner" /> : null}
        {multi ? <MultiSelect {...dropDownProps} /> : <PrimeDropdown {...dropDownProps} />}
      </div>
      <small className={props.error ? classes.error : classes.hint}>{props.error ? props.error : props.hint}</small>
    </div>
  )
}


export const Dropdown = (props: DropdownProps) => (
  !props.control
    ? <SimpleDropdown {...props} />
    : <Controller
        render={({ field: { ref, ...field } }) => <SimpleDropdown {...field} {...props} inputRef={ref} /> }
        name={props.name}
        control={props.control}
    />
);
